import {
  ASSET_STOCK_TAKING_UPLOAD_COUNT_DECREASE,
  ASSET_STOCK_TAKING_UPLOAD_COUNT_INCREASE,
  CHECK_ASSET_STOCK_TAKING_SUCCESS,
  CLEAR_ASSET_STOCK_TAKING_DATA_SUCCESS,
  CREATE_ASSET_STOCK_TAKING_SUCCESS,
  FETCH_ASSET_STOCK_TAKING_SUCCESS,
  GET_ASSET_STOCK_TAKING_SUCCESS,
  GET_AST_ASSETS_BY_VOUCHER_SUCCESS,
  GET_AST_COMBINE_REPORT_SUCCESS,
  GET_VERIFIED_ASSET_COUNT_START,
  GET_VERIFIED_ASSET_COUNT_SUCCESS,
  SAVE_ASSET_STOCK_TAKING_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  astUploadCount: 0,
  warning: {},
  verifiedAssetCount: 0,
  verifiedAssetCountLoading: false,
  combineReportData: [],
  auditVoucherASTAssets: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ASSET_STOCK_TAKING_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_ASSET_STOCK_TAKING_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_ASSET_STOCK_TAKING_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case CHECK_ASSET_STOCK_TAKING_SUCCESS: {
      return {
        ...state,
        warning: action.data,
      }
    }

    case FETCH_ASSET_STOCK_TAKING_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case CLEAR_ASSET_STOCK_TAKING_DATA_SUCCESS: {
      return {
        ...state,
        edit: {},
      }
    }

    case ASSET_STOCK_TAKING_UPLOAD_COUNT_INCREASE: {
      return { ...state, astUploadCount: state.astUploadCount + 1 };
    }

    case ASSET_STOCK_TAKING_UPLOAD_COUNT_DECREASE: {
      return { ...state, astUploadCount: state.astUploadCount - 1 };
    }

    case GET_VERIFIED_ASSET_COUNT_SUCCESS: {
      return {
        ...state,
        verifiedAssetCount: action.count,
        verifiedAssetCountLoading: false
      }
    }
    case GET_VERIFIED_ASSET_COUNT_START: {
      return {
        ...state,
        verifiedAssetCountLoading: true
      };
    }
    case GET_AST_COMBINE_REPORT_SUCCESS: {
      return {
        ...state,
        combineReportData: action.data
      };
    }
    case GET_AST_ASSETS_BY_VOUCHER_SUCCESS: {
      return {
        ...state,
        auditVoucherASTAssets: action.data
      };
    }


    default:
      return state;
  }
}
